angular.module('logbook')
	.directive('lazyTabset', ['$route', '$rootScope', '$location', '$uibModal', '$templateCache', 'logService', function($route, $rootScope, $location, $uibModal, $templateCache, logService) {
		let settingsTemplates = ['log', 'users', 'groups', 'tags', 'shifts', 'templates', 'choice-lists', 'alerts', 'config', 'provisioning', 'onsite-config', 'delete'];
			
		settingsTemplates.forEach(template => {
			let url = `log-detail-${template}.html`;

			$templateCache.put(url, require(`./tabs/${url}`));
		});
		
		return {
			restrict: 'E',
			replace: true,
			transclude: true,
			template:
				`<div class="row-fluid">
					<div class="row-fluid">
						<div class="nav nav-tabs" ng-transclude></div>
					</div>
					<div class="row-fluid">
						<ng-include src="templateUrl">
						</ng-include>
					</div> 
				</div>`,
			controller: ['$scope', function($scope) {
				$scope.templateUrl = '';
				var tabs = $scope.tabs = [];
				var tabMap = {};
				var controller = this;
 
				// Whether to prompt a message when attempting to switch tabs
				var needsConfirm = false;
				var confirmMsg = '';
				
				const _logChangeStartSubscription = logService.logChangeStart$.subscribe(changeLog => {
					if (displayHaltModal(null, changeLog))
						changeLog();
				});
      
				this.selectTab = $scope.selectTab = function(tab, setParam) {
					if (!displayHaltModal(null, function() {
						controller.selectTab(tab, setParam);
					}))
						return false;
					$scope.tab = tab;
					setParam = setParam == undefined ? true : !!setParam;
					angular.forEach(tabs, function(tab) {
						tab.selected = false;
					});
					tab.selected = true;
        
					if (setParam) {
						var needsReplace = !$location.search()['tab'];
						var loc = $location.search('tab', tab.title.toLowerCase());
          
						// Replace the $location update if no previous tab parameter was set
						if (needsReplace)
							loc.replace();
					}
					return true;
				};
 
				this.setTabTemplate = function(templateUrl) {
					$scope.templateUrl = templateUrl;
				};
 
				this.addTab = function(tab) {
					tabs.push(tab);
					tabMap[tab.title.toLowerCase()] = tab;
					var searchIncludes = $location.search()['tab'] === tab.title.toLowerCase();
					if (tabs.length === 1 || searchIncludes) {
						controller.selectTab(tab, searchIncludes || !$location.search()['tab']);
					}
				};
  
				$scope.$on('setLazyTabsetConfirm', function(event, value, msg) {
					needsConfirm = typeof value === 'function' ? value : !!value;
					confirmMsg = (typeof msg === 'string') ? msg : '';
				});
      
				$scope.$on('$locationChangeSuccess', function() {
					var val = $location.search()['tab'];
					if (typeof val !== 'string' || !val)
						return;
        
					var tab = tabMap[val.toLowerCase()];
					if (tab)
						$scope.selectTab(tab);
        
				});
  
				/**
				 * Displays a navigation warning modal if conditions are met
				 * @param event - Event to prevent default on if provided
				 * @param callback - Callback to execute if the user confirms to leave
				 *
				 * @return {boolean} - whether navigation can proceed without the modal being displayed
				 */
				function displayHaltModal(event, callback) {
					if (!($rootScope.user !== null && (typeof needsConfirm === 'function') ? needsConfirm() : needsConfirm) && !controller.modalOpen)
						return true;
        
					if (event && typeof event.preventDefault === 'function') {
						event.preventDefault();
						if (event.name === '$locationChangeStart')
							$scope.$emit('$routeChangeError');
					}
        
					if (controller.modalOpen)
						return false;
        
					$uibModal.open({
						backdrop: 'static',
						template: require('../shared/modals/modal-confirm.html'),
						controller: ['$scope', function(scope) {
							scope.message = (confirmMsg.length <= 0) ? 'You will lose any unsaved progress.' : confirmMsg
						}]
					})
						.result
						.then(function() {
							controller.modalOpen = false;
							needsConfirm = false;
							if (typeof callback === 'function')
								callback();
						})
						.finally(function() {
							controller.modalOpen = false;
						})
        
					controller.modalOpen = true;
					return false;
				}
  
				function beforeUnload(event) {
					if ($rootScope.user !== null && (typeof needsConfirm === 'function' ? needsConfirm() : needsConfirm)) {
						event.returnValue = confirmMsg.length <= 0 ? 'You will lose any unsaved progress.' : confirmMsg;
						event.preventDefault();
					}
					else {
						needsConfirm = false;
						delete event['returnValue'];
					}
    
					return event.returnValue;
				}
      
				$scope.$on('helpOpening', function($event, help) {
					if ($scope.tab && $scope.tab.helpSection)
						help.setSection($scope.tab.helpSection);
				})
      
				$scope.$on('logoutStart', displayHaltModal);
				$scope.$on('$locationChangeStart', function(event) {
					var gotoUrl = $location.url();
					displayHaltModal(event, function() {
						$location.url(gotoUrl);
					});
				});
				$scope.$on('logoutSuccess', function() {
					needsConfirm = false;
				});
      
				$(window).on('beforeunload', beforeUnload);
				
				$scope.$on('$destroy', function() {
					// Deletes help button override.
					delete $route.current.tabbedHelp;
					$(window).off('beforeunload', beforeUnload);
					
					_logChangeStartSubscription.unsubscribe();
				});
			}]
		};
	}]);
